import classNames from 'classnames';
import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import * as IPurchases from '../../../../../../interfaces/merchants/products/purchases';

import css from './PurchaseErrorMessage.module.scss';

interface Props {
  labelType: string;
  errorType: IPurchases.EntireErrorType;
  className?: string;
}

const PurchaseErrorMessage = ({
  className,
  intl,
  errorType,
  labelType,
}: Props & InjectedIntlProps) => {
  const classes = classNames(css.PurchaseErrorMessage, className);
  let errorText: { [key: string]: string } = {};
  if (errorType === 'unexpected') {
    errorText = {
      description: `text.${errorType}.${labelType}`,
      title: 'title',
    };
  } else {
    errorText = {
      description: `text.${errorType}`,
      title: 'title',
    };
  }
  return (
    <div className={classes}>
      <p className={css.PurchaseErrorMessage__Title}>
        {intl.formatMessage({
          id: `purchases.purchaseErrorMessage.${errorText.title}`,
        })}
      </p>
      <p className={css.PurchaseErrorMessage__Paragraph}>
        {intl.formatMessage({
          id: `purchases.purchaseErrorMessage.${errorText.description}`,
        })}
      </p>
    </div>
  );
};

export default injectIntl(PurchaseErrorMessage);
